import { Routes, Route } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { ProtectedRoute, RoleRoute } from "@/app/ProtectedRoute";
import { useBranding } from "@/lib/branding";

import { LoginPage } from "@/pages/LoginPage";
import { RegisterPage } from "@/pages/RegisterPage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";
import { SsoCallbackPage } from "@/pages/SsoCallbackPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { CourseCatalogPage } from "@/pages/CourseCatalogPage";
import { CourseDetailPage } from "@/pages/CourseDetailPage";
import { CourseBuilderPage } from "@/pages/CourseBuilderPage";
import { QuizTakerPage } from "@/pages/QuizTakerPage";
import { QuizResultsPage } from "@/pages/QuizResultsPage";
import { AssignmentDetailPage } from "@/pages/AssignmentDetailPage";
import { MyLearningPage } from "@/pages/MyLearningPage";
import { CertificatesPage } from "@/pages/CertificatesPage";
import { CategoriesPage } from "@/pages/CategoriesPage";
import { UsersPage } from "@/pages/UsersPage";
import { AnalyticsPage } from "@/pages/AnalyticsPage";
import { AuditLogsPage } from "@/pages/AuditLogsPage";
import { NotificationsPage } from "@/pages/NotificationsPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { NotFoundPage } from "@/pages/NotFoundPage";

export function App() {
  useBranding();

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/sso/callback" element={<SsoCallbackPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/courses" element={<CourseCatalogPage />} />
          <Route path="/courses/:id" element={<CourseDetailPage />} />
          <Route path="/quizzes/:id/take" element={<QuizTakerPage />} />
          <Route path="/assignments/:id" element={<AssignmentDetailPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />

          <Route element={<RoleRoute roles={["student"]} />}>
            <Route path="/my-learning" element={<MyLearningPage />} />
            <Route path="/certificates" element={<CertificatesPage />} />
          </Route>

          <Route element={<RoleRoute roles={["admin", "instructor"]} />}>
            <Route path="/courses/:id/edit" element={<CourseBuilderPage />} />
            <Route path="/quizzes/:id/results" element={<QuizResultsPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
          </Route>

          <Route element={<RoleRoute roles={["admin"]} />}>
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/audit-logs" element={<AuditLogsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
